import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import JobShiftEmergencyPlanHeader from "./JobShiftEmergencyPlanHeader";
import EmergencyPlanDetails from "./sections/EmergencyPlanDetails";
import EmergencyPlanDocumentAuthorization from "./sections/EmergencyPlanDocumentAuthorization";
import EmergencyPlanAlarmCommunicationSection from "./sections/EmergencyPlanAlarmCommunicationSection";
import EmergencyPlanContactsSection from "./sections/EmergencyPlanContactsSection";
import EmergencyPlanResponseProcedureSection from "./sections/EmergencyPlanResponseProcedureSection";
import EmergencyPlanForeseeableRescueScenariosSection from "./sections/EmergencyPlanForeseeableRescueScenariosSection";
import EmergencyPlanMedicalConsiderationsSection from "./sections/EmergencyPlanMedicalConsiderationsSection";
import EmergencyPlanPostRescueNotificationSection from "./sections/EmergencyPlanPostRescueNotificationSection";
import EmergencyPlanRolesResponsibilitiesSection from "./sections/EmergencyPlanRolesResponsibilitiesSection";
import EmergencyPlanCustomSection from "./sections/EmergencyPlanCustomSection";
import EmergencyPlanRescueEquipmentSection from "./sections/EmergencyPlanRescueEquipmentSection";
import EmergencyPlanSignOffSection from "./sections/EmergencyPlanSignOffSection";

const getPlanList = (plans, onlyEnabled = false) => {
  let planList = [];
  if (plans && plans.emergency_plans && Array.isArray(plans.emergency_plans.plans)) {
    planList = plans.emergency_plans.plans;
  } else if (plans && Array.isArray(plans.plans)) {
    planList = plans.plans;
  } else if (plans && Array.isArray(plans.emergency_plans)) {
    planList = plans.emergency_plans;
  } else if (plans && plans.document && Array.isArray(plans.document.plans)) {
    planList = plans.document.plans;
  }

  return onlyEnabled ? planList.filter((plan) => plan && plan.toggle === 1) : planList;
};

export { getPlanList };

const getOrderedEnabledSections = (plan) => {
  const sections = Array.isArray(plan && plan.sections) ? plan.sections : [];
  const sectionById = sections.reduce((result, section) => {
    if (section && section.id) result[section.id] = section;
    return result;
  }, {});

  return (Array.isArray(plan && plan.section_order) ? plan.section_order : [])
    .map((sectionId) => sectionById[sectionId])
    .filter((section) => section && section.data && section.data.toggle === 1);
};

const getPlanKey = (plan, index) => `${plan && (plan.id || plan.plan_id || plan.document_number || index)}`;
const getAnchor = (planKey, suffix) => `emergency-plan-${planKey}-${suffix}`;

export default function JobShiftEmergencyPlansDocument({ plans, sections, context, embedded = false, withNavigationAnchors = false }) {
  const planList = getPlanList(plans, embedded);

  const content = (
    <main>
        <div style={{ background: "transparent" }}>
          {planList.map((plan, index) => (
            <div
              key={getPlanKey(plan, index)}
              className={styles.PreviewDoc}
              style={{
                minHeight: "180px",
                marginBottom: index === planList.length - 1 ? 0 : "24px"
              }}
            >
              <div id={withNavigationAnchors ? getAnchor(getPlanKey(plan, index), "details") : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                <JobShiftEmergencyPlanHeader plan={plan} index={index} sections={sections} context={context} />
                <EmergencyPlanDetails plan={plan} sections={sections} context={context} />
              </div>
              <div id={withNavigationAnchors ? getAnchor(getPlanKey(plan, index), "authorization") : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                <EmergencyPlanDocumentAuthorization plan={plan} sections={sections} />
              </div>
              {getOrderedEnabledSections(plan).map((section, sectionIndex) => (
                <div key={section.id} id={withNavigationAnchors ? getAnchor(getPlanKey(plan, index), section.id) : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                {section.id === "alarm_communication_emergency_access"
                    ? <EmergencyPlanAlarmCommunicationSection section={section} sectionNumber={sectionIndex + 3} />
                    : section.id === "emergency_contacts"
                      ? <EmergencyPlanContactsSection section={section} sectionNumber={sectionIndex + 3} />
                    : section.id === "emergency_response_procedure"
                        ? <EmergencyPlanResponseProcedureSection section={section} sectionNumber={sectionIndex + 3} />
                        : section.id === "foreseeable_rescue_scenarios"
                          ? <EmergencyPlanForeseeableRescueScenariosSection section={section} plan={plan} sectionNumber={sectionIndex + 3} />
                          : section.id === "medical_considerations"
                            ? <EmergencyPlanMedicalConsiderationsSection section={section} sectionNumber={sectionIndex + 3} />
                            : section.id === "post_rescue_notification"
                              ? <EmergencyPlanPostRescueNotificationSection section={section} sectionNumber={sectionIndex + 3} />
                              : section.id === "roles_responsibilities_competency"
                                ? <EmergencyPlanRolesResponsibilitiesSection section={section} sectionNumber={sectionIndex + 3} />
                                : section.type === "custom"
                                  ? <EmergencyPlanCustomSection section={section} sectionNumber={sectionIndex + 3} />
                                : section.id === "rescue_equipment_staging"
                                  ? <EmergencyPlanRescueEquipmentSection section={section} sectionNumber={sectionIndex + 3} />
                    : null}
                </div>
              ))}
              <div id={withNavigationAnchors ? getAnchor(getPlanKey(plan, index), "signoff") : undefined} style={withNavigationAnchors ? { scrollMarginTop: "140px" } : undefined}>
                <EmergencyPlanSignOffSection
                    staffSignOff={plans && plans.staff_sign_off}
                    sectionNumber={getOrderedEnabledSections(plan).length + 3}
                />
              </div>
            </div>
          ))}
        </div>
      </main>
  );

  return embedded ? content : <div className={styles.PreviewWrap}>{content}</div>;
}
